// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTable-VeloTableError_cls1__TpUu2","cls2":"VeloTable-VeloTableError_cls2__d5fOM VeloTable-VeloTableError_cls1__TpUu2"};